import * as React from "react"
import usePhotoViewer from "./usePhotoViewer";
import "./photoViewer.css"

const PhotoViewer = () => {
  const { image, handleZoomOutImage } = usePhotoViewer();
  return (
    <div className={`photo-viewer ${image.isZoomed && 'active'}`}>
      <div className="photo-viewer__backdrop" onClick={() => handleZoomOutImage()} />
      <div className="photo-viewer__image-container">
        <button className="photo-viewer__btn-close" onClick={() => handleZoomOutImage()}>
          <span className="fa fa-times"/>
        </button>
        <div className="photo-viewer__image bounding-boxes__container">
          <img src={image.source} alt="Portrait"/>
          {image.boundingBoxes.map((boundedFace, index) => (
            <div key={index}>
              <div className="bounding-box" style={boundedFace.box} />
              <span style={{ top: boundedFace.box.top, left: boundedFace.box.left }}>
                {boundedFace.isMatch && `${Math.round(boundedFace.similarity)}%`}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default React.memo(PhotoViewer)



// WEBPACK FOOTER //
// ./src/share/components/PhotoViewer/PhotoViewer.tsx